/**
 * resourceNotAttached模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceNotAttached = {
    //查询未挂载的资源
    selectNotAttached(params) {
      return $http.post(`${global.API_URL}/sme/resourceNotAttached/selectNotAttached`,params);
    },
    //备份时间
    getBackupTime(params) {
      return $http.post(`${global.API_URL}/sme/resourceNotAttached/getBackupTime`,params);
    }
    
}

export default resourceNotAttached;



// WEBPACK FOOTER //
// ./src/api/resourceNotAttached.js